// World Manufacturer Identifier (WMI) lookup tables — ISO 3780.
// The first 3 characters of a VIN identify the manufacturer's country
// and brand. We use prefix-matching: the longest prefix wins so that
// 3-char codes (e.g. "ZFF" Ferrari) override 2-char ones (e.g. "ZF").
//
// Coverage is intentionally focused on the European market (LoJack's
// primary customer base) plus the most common imported brands.
// References: NHTSA WMI registry, SAE J853, vPIC database.

// 2-character country prefixes (ISO 3780 region+country).
// Used as the FALLBACK when no 3-char manufacturer match is found.
const COUNTRY_PREFIXES_2 = {
  // North America
  '1': { country: 'Stati Uniti', code: 'US' },
  '4': { country: 'Stati Uniti', code: 'US' },
  '5': { country: 'Stati Uniti', code: 'US' },
  '2': { country: 'Canada', code: 'CA' },
  '3': { country: 'Messico', code: 'MX' },
  // South America
  '8A': { country: 'Argentina', code: 'AR' }, '8B': { country: 'Argentina', code: 'AR' },
  '8C': { country: 'Argentina', code: 'AR' }, '8D': { country: 'Argentina', code: 'AR' },
  '8E': { country: 'Argentina', code: 'AR' },
  '8X': { country: 'Venezuela', code: 'VE' }, '8Y': { country: 'Venezuela', code: 'VE' },
  '8Z': { country: 'Venezuela', code: 'VE' },
  '9A': { country: 'Brasile', code: 'BR' }, '9B': { country: 'Brasile', code: 'BR' },
  '9C': { country: 'Brasile', code: 'BR' }, '9D': { country: 'Brasile', code: 'BR' },
  '9E': { country: 'Brasile', code: 'BR' },
  // Asia
  'J': { country: 'Giappone', code: 'JP' },
  'KL': { country: 'Corea del Sud', code: 'KR' }, 'KM': { country: 'Corea del Sud', code: 'KR' },
  'KN': { country: 'Corea del Sud', code: 'KR' }, 'KP': { country: 'Corea del Sud', code: 'KR' },
  'KR': { country: 'Corea del Sud', code: 'KR' },
  'L': { country: 'Cina', code: 'CN' },
  'MA': { country: 'India', code: 'IN' }, 'MB': { country: 'India', code: 'IN' },
  'MC': { country: 'India', code: 'IN' }, 'MD': { country: 'India', code: 'IN' },
  'ME': { country: 'India', code: 'IN' },
  'MF': { country: 'Indonesia', code: 'ID' }, 'MH': { country: 'Indonesia', code: 'ID' },
  'MM': { country: 'Thailandia', code: 'TH' }, 'MR': { country: 'Thailandia', code: 'TH' },
  'MS': { country: 'Myanmar', code: 'MM' },
  // Africa
  'AA': { country: 'Sudafrica', code: 'ZA' }, 'AC': { country: 'Sudafrica', code: 'ZA' },
  'AH': { country: 'Sudafrica', code: 'ZA' },
  // Europe — country-level prefixes
  'SA': { country: 'Regno Unito', code: 'UK' }, 'SB': { country: 'Regno Unito', code: 'UK' },
  'SC': { country: 'Regno Unito', code: 'UK' }, 'SD': { country: 'Regno Unito', code: 'UK' },
  'SE': { country: 'Regno Unito', code: 'UK' }, 'SF': { country: 'Regno Unito', code: 'UK' },
  'SG': { country: 'Regno Unito', code: 'UK' }, 'SH': { country: 'Regno Unito', code: 'UK' },
  'SJ': { country: 'Regno Unito', code: 'UK' }, 'SK': { country: 'Regno Unito', code: 'UK' },
  'SL': { country: 'Regno Unito', code: 'UK' }, 'SM': { country: 'Regno Unito', code: 'UK' },
  'SN': { country: 'Germania', code: 'DE' }, 'SP': { country: 'Germania', code: 'DE' },
  'SR': { country: 'Germania', code: 'DE' }, 'SS': { country: 'Germania', code: 'DE' },
  'ST': { country: 'Germania', code: 'DE' },
  'SU': { country: 'Polonia', code: 'PL' }, 'SW': { country: 'Polonia', code: 'PL' },
  'SX': { country: 'Polonia', code: 'PL' }, 'SY': { country: 'Polonia', code: 'PL' },
  'SZ': { country: 'Polonia', code: 'PL' },
  'TA': { country: 'Svizzera', code: 'CH' }, 'TB': { country: 'Svizzera', code: 'CH' },
  'TC': { country: 'Svizzera', code: 'CH' }, 'TD': { country: 'Svizzera', code: 'CH' },
  'TE': { country: 'Svizzera', code: 'CH' }, 'TF': { country: 'Svizzera', code: 'CH' },
  'TG': { country: 'Svizzera', code: 'CH' }, 'TH': { country: 'Svizzera', code: 'CH' },
  'TJ': { country: 'Repubblica Ceca', code: 'CZ' }, 'TK': { country: 'Repubblica Ceca', code: 'CZ' },
  'TL': { country: 'Repubblica Ceca', code: 'CZ' }, 'TM': { country: 'Repubblica Ceca', code: 'CZ' },
  'TN': { country: 'Ungheria', code: 'HU' }, 'TP': { country: 'Ungheria', code: 'HU' },
  'TR': { country: 'Ungheria', code: 'HU' }, 'TS': { country: 'Ungheria', code: 'HU' },
  'TT': { country: 'Ungheria', code: 'HU' },
  'TU': { country: 'Portogallo', code: 'PT' }, 'TV': { country: 'Portogallo', code: 'PT' },
  'TW': { country: 'Portogallo', code: 'PT' },
  'TY': { country: 'Lussemburgo', code: 'LU' }, 'TZ': { country: 'Lussemburgo', code: 'LU' },
  'UH': { country: 'Danimarca', code: 'DK' }, 'UN': { country: 'Irlanda', code: 'IRL' },
  'UU': { country: 'Romania', code: 'RO' }, 'UV': { country: 'Romania', code: 'RO' },
  'UW': { country: 'Romania', code: 'RO' }, 'UX': { country: 'Romania', code: 'RO' },
  'UZ': { country: 'Romania', code: 'RO' },
  'V': { country: 'Spagna', code: 'ES' },  // VS=Spain SEAT
  'VA': { country: 'Austria', code: 'AT' }, 'VB': { country: 'Austria', code: 'AT' },
  'VC': { country: 'Austria', code: 'AT' }, 'VD': { country: 'Austria', code: 'AT' },
  'VE': { country: 'Austria', code: 'AT' },
  'VF': { country: 'Francia', code: 'FR' }, 'VG': { country: 'Francia', code: 'FR' },
  'VH': { country: 'Francia', code: 'FR' }, 'VJ': { country: 'Francia', code: 'FR' },
  'VK': { country: 'Francia', code: 'FR' }, 'VL': { country: 'Francia', code: 'FR' },
  'VM': { country: 'Francia', code: 'FR' }, 'VN': { country: 'Francia', code: 'FR' },
  'VP': { country: 'Francia', code: 'FR' }, 'VR': { country: 'Francia', code: 'FR' },
  'VS': { country: 'Spagna', code: 'ES' }, 'VT': { country: 'Spagna', code: 'ES' },
  'VU': { country: 'Spagna', code: 'ES' }, 'VV': { country: 'Spagna', code: 'ES' },
  'VW': { country: 'Spagna', code: 'ES' }, 'VX': { country: 'Spagna', code: 'ES' },
  'VY': { country: 'Spagna', code: 'ES' }, 'VZ': { country: 'Spagna', code: 'ES' },
  'W': { country: 'Germania', code: 'DE' },  // All W* = Germany
  'X': { country: 'Russia', code: 'RU' },  // X* = ex-USSR
  'XL': { country: 'Paesi Bassi', code: 'NL' }, 'XM': { country: 'Bulgaria', code: 'BG' },
  'Y': { country: 'Svezia', code: 'SE' },  // Most Y* = Sweden
  'YA': { country: 'Belgio', code: 'BE' }, 'YB': { country: 'Belgio', code: 'BE' },
  'YC': { country: 'Belgio', code: 'BE' }, 'YD': { country: 'Belgio', code: 'BE' },
  'YE': { country: 'Belgio', code: 'BE' },
  'YH': { country: 'Finlandia', code: 'FI' }, 'YK': { country: 'Finlandia', code: 'FI' },
  'YS': { country: 'Svezia', code: 'SE' },
  'YT': { country: 'Norvegia', code: 'NO' }, 'YU': { country: 'Norvegia', code: 'NO' },
  'YV': { country: 'Svezia', code: 'SE' },
  'YW': { country: 'Bielorussia', code: 'BY' }, 'YX': { country: 'Bielorussia', code: 'BY' },
  'YZ': { country: 'Polonia', code: 'PL' },
  'Z': { country: 'Italia', code: 'IT' },  // Z* = Italy
  'ZA': { country: 'Italia', code: 'IT' }, 'ZB': { country: 'Italia', code: 'IT' },
  'ZC': { country: 'Italia', code: 'IT' }, 'ZD': { country: 'Italia', code: 'IT' },
  'ZE': { country: 'Italia', code: 'IT' }, 'ZF': { country: 'Italia', code: 'IT' },
  'ZG': { country: 'Italia', code: 'IT' }, 'ZH': { country: 'Italia', code: 'IT' },
  'ZJ': { country: 'Italia', code: 'IT' }, 'ZK': { country: 'Italia', code: 'IT' },
  'ZL': { country: 'Italia', code: 'IT' }, 'ZM': { country: 'Italia', code: 'IT' },
  'ZN': { country: 'Italia', code: 'IT' }, 'ZP': { country: 'Italia', code: 'IT' },
  'ZR': { country: 'Italia', code: 'IT' },
};

// 3-character WMI codes — manufacturer + country.
// Longest-prefix match wins over the 2-char lookup above.
const MANUFACTURERS_3 = {
  // Italy
  'ZFA': { brand: 'Fiat', country: 'Italia', code: 'IT' },
  'ZFC': { brand: 'Fiat (commerciale)', country: 'Italia', code: 'IT' },
  'ZFF': { brand: 'Ferrari', country: 'Italia', code: 'IT' },
  'ZAR': { brand: 'Alfa Romeo', country: 'Italia', code: 'IT' },
  'ZAM': { brand: 'Maserati', country: 'Italia', code: 'IT' },
  'ZHW': { brand: 'Lamborghini', country: 'Italia', code: 'IT' },
  'ZLA': { brand: 'Lancia', country: 'Italia', code: 'IT' },
  'ZCG': { brand: 'Piaggio', country: 'Italia', code: 'IT' },
  'ZDM': { brand: 'Ducati', country: 'Italia', code: 'IT' },
  'ZAP': { brand: 'Piaggio', country: 'Italia', code: 'IT' },
  // Germany
  'WAU': { brand: 'Audi', country: 'Germania', code: 'DE' },
  'WA1': { brand: 'Audi SUV', country: 'Germania', code: 'DE' },
  'WBA': { brand: 'BMW', country: 'Germania', code: 'DE' },
  'WBS': { brand: 'BMW M', country: 'Germania', code: 'DE' },
  'WBY': { brand: 'BMW i', country: 'Germania', code: 'DE' },
  'WBX': { brand: 'BMW SUV', country: 'Germania', code: 'DE' },
  'WDB': { brand: 'Mercedes-Benz', country: 'Germania', code: 'DE' },
  'WDC': { brand: 'Mercedes-Benz SUV', country: 'Germania', code: 'DE' },
  'WDD': { brand: 'Mercedes-Benz', country: 'Germania', code: 'DE' },
  'WDF': { brand: 'Mercedes-Benz commerciale', country: 'Germania', code: 'DE' },
  'W1K': { brand: 'Mercedes-Benz (2021+)', country: 'Germania', code: 'DE' },
  'W1N': { brand: 'Mercedes-Benz SUV (2021+)', country: 'Germania', code: 'DE' },
  'WP0': { brand: 'Porsche', country: 'Germania', code: 'DE' },
  'WP1': { brand: 'Porsche SUV', country: 'Germania', code: 'DE' },
  'WVW': { brand: 'Volkswagen', country: 'Germania', code: 'DE' },
  'WV1': { brand: 'Volkswagen commerciale', country: 'Germania', code: 'DE' },
  'WV2': { brand: 'Volkswagen commerciale', country: 'Germania', code: 'DE' },
  'WVG': { brand: 'Volkswagen SUV', country: 'Germania', code: 'DE' },
  'WMW': { brand: 'MINI', country: 'Germania', code: 'DE' },
  'WME': { brand: 'Smart', country: 'Germania', code: 'DE' },
  'WMA': { brand: 'MAN', country: 'Germania', code: 'DE' },
  // France
  'VF1': { brand: 'Renault', country: 'Francia', code: 'FR' },
  'VF2': { brand: 'Renault', country: 'Francia', code: 'FR' },
  'VF3': { brand: 'Peugeot', country: 'Francia', code: 'FR' },
  'VF6': { brand: 'Renault Trucks', country: 'Francia', code: 'FR' },
  'VF7': { brand: 'Citroen', country: 'Francia', code: 'FR' },
  'VF8': { brand: 'Matra', country: 'Francia', code: 'FR' },
  'VF9': { brand: 'Bugatti', country: 'Francia', code: 'FR' },
  'VR1': { brand: 'Dacia', country: 'Francia/Romania', code: 'FR' },
  // UK
  'SAJ': { brand: 'Jaguar', country: 'Regno Unito', code: 'UK' },
  'SAL': { brand: 'Land Rover', country: 'Regno Unito', code: 'UK' },
  'SAR': { brand: 'Rover', country: 'Regno Unito', code: 'UK' },
  'SCC': { brand: 'Lotus', country: 'Regno Unito', code: 'UK' },
  'SCB': { brand: 'Bentley', country: 'Regno Unito', code: 'UK' },
  'SCF': { brand: 'Aston Martin', country: 'Regno Unito', code: 'UK' },
  'SCA': { brand: 'Rolls-Royce', country: 'Regno Unito', code: 'UK' },
  'SBM': { brand: 'McLaren', country: 'Regno Unito', code: 'UK' },
  // Spain
  'VSS': { brand: 'SEAT', country: 'Spagna', code: 'ES' },
  'VWV': { brand: 'Volkswagen Navarra', country: 'Spagna', code: 'ES' },
  // Sweden
  'YV1': { brand: 'Volvo Cars', country: 'Svezia', code: 'SE' },
  'YV4': { brand: 'Volvo SUV', country: 'Svezia', code: 'SE' },
  'YS3': { brand: 'Saab', country: 'Svezia', code: 'SE' },
  'YS2': { brand: 'Scania', country: 'Svezia', code: 'SE' },
  // Czech Republic
  'TMB': { brand: 'Skoda', country: 'Repubblica Ceca', code: 'CZ' },
  // South Korea
  'KMH': { brand: 'Hyundai', country: 'Corea del Sud', code: 'KR' },
  'KNA': { brand: 'KIA', country: 'Corea del Sud', code: 'KR' },
  'KNC': { brand: 'KIA', country: 'Corea del Sud', code: 'KR' },
  'KND': { brand: 'KIA', country: 'Corea del Sud', code: 'KR' },
  'KNM': { brand: 'Renault Samsung', country: 'Corea del Sud', code: 'KR' },
  // Japan
  'JHM': { brand: 'Honda', country: 'Giappone', code: 'JP' },
  'JHL': { brand: 'Honda', country: 'Giappone', code: 'JP' },
  'JN1': { brand: 'Nissan', country: 'Giappone', code: 'JP' },
  'JN8': { brand: 'Nissan SUV', country: 'Giappone', code: 'JP' },
  'JT1': { brand: 'Toyota', country: 'Giappone', code: 'JP' },
  'JT2': { brand: 'Toyota', country: 'Giappone', code: 'JP' },
  'JT3': { brand: 'Toyota', country: 'Giappone', code: 'JP' },
  'JTD': { brand: 'Toyota', country: 'Giappone', code: 'JP' },
  'JTL': { brand: 'Lexus', country: 'Giappone', code: 'JP' },
  'JTH': { brand: 'Lexus', country: 'Giappone', code: 'JP' },
  'JF1': { brand: 'Subaru', country: 'Giappone', code: 'JP' },
  'JF2': { brand: 'Subaru', country: 'Giappone', code: 'JP' },
  'JM1': { brand: 'Mazda', country: 'Giappone', code: 'JP' },
  'JM3': { brand: 'Mazda', country: 'Giappone', code: 'JP' },
  'JS3': { brand: 'Suzuki', country: 'Giappone', code: 'JP' },
  'JSA': { brand: 'Suzuki', country: 'Giappone', code: 'JP' },
  'JYA': { brand: 'Yamaha', country: 'Giappone', code: 'JP' },
  // USA
  '1FA': { brand: 'Ford', country: 'Stati Uniti', code: 'US' },
  '1FT': { brand: 'Ford truck', country: 'Stati Uniti', code: 'US' },
  '1G1': { brand: 'Chevrolet', country: 'Stati Uniti', code: 'US' },
  '1GC': { brand: 'Chevrolet truck', country: 'Stati Uniti', code: 'US' },
  '1HG': { brand: 'Honda (USA)', country: 'Stati Uniti', code: 'US' },
  '5YJ': { brand: 'Tesla', country: 'Stati Uniti', code: 'US' },
  '7SA': { brand: 'Tesla', country: 'Stati Uniti', code: 'US' },
};

/**
 * Detect the country of origin and (when known) the manufacturer/brand
 * from the WMI (first 3 chars of the VIN). Returns:
 *   {
 *     country: "Italia" | null,        // human-readable, in Italian
 *     code:    "IT" | null,            // platform country code
 *     brand:   "Ferrari" | null,       // if 3-char match
 *     confidence: 'high' | 'medium' | 'low' | 'none',
 *   }
 */
export function detectVinOrigin(rawVin) {
  const vin = String(rawVin || '').toUpperCase().replace(/\s+/g, '');
  if (vin.length < 3) {
    return { country: null, code: null, brand: null, confidence: 'none' };
  }
  const w3 = vin.slice(0, 3);
  const w2 = vin.slice(0, 2);
  const w1 = vin.slice(0, 1);

  // 1. Exact 3-char manufacturer match (highest confidence)
  if (MANUFACTURERS_3[w3]) {
    const m = MANUFACTURERS_3[w3];
    return { country: m.country, code: m.code, brand: m.brand, confidence: 'high' };
  }
  // 2. 2-char country prefix
  if (COUNTRY_PREFIXES_2[w2]) {
    const c = COUNTRY_PREFIXES_2[w2];
    return { country: c.country, code: c.code, brand: null, confidence: 'medium' };
  }
  // 3. 1-char region/country prefix
  if (COUNTRY_PREFIXES_2[w1]) {
    const c = COUNTRY_PREFIXES_2[w1];
    return { country: c.country, code: c.code, brand: null, confidence: 'low' };
  }
  return { country: null, code: null, brand: null, confidence: 'none' };
}

export default detectVinOrigin;
